import React, { useEffect, useState } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Spinner from "react-bootstrap/Spinner";

import { axiosInstance } from "../../utils/axios-instance";

import { useNavigate, useSearchParams } from "react-router-dom";

import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";

import { selectSignIn } from "../../store/slices/signed-in-slice";
import {toast} from 'react-toastify';

export const VerifyAccount = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const isSignedIn = useSelector(selectSignIn);
    const [searchParams] = useSearchParams();

    const [verified, setVerified] = useState(false);
    const [loading, setLoading] = useState(false);
    const ToastID = React.useRef(null)

    // Get token in url '?token={token}&id={id}'
    const token = searchParams.get("token");
    // Get id in url '?token={token}&id={id}'
    const id = searchParams.get("id");

    // If the id or token in the URL param is empty, navigate to a different page
    useEffect(() => {
        if (id === null || token === null) {
            navigate("/signin");
        }
    });

    // If user is signed in,
    // redirect to the home page
    useEffect(() => {
        if (isSignedIn) {
            navigate("/");
        }
    }, [dispatch, isSignedIn, navigate]);

    const verifyEmail = async () => {
        try {
            await axiosInstance({
                method: "post",
                url: "/verify-account",
                headers: {
                    "Content-Type": "application/json",
                },
                data: {
                    token: token,
                    id: id,
                },
            });
            toast.update(ToastID.current , {render: `Successfully Verified Account`, type: "success", isLoading: false, theme: "colored", autoClose: "3500",  containerId:"root", position: "top-center"} )
            setVerified(true);
            setLoading(false);
            setTimeout(() => {
                navigate("/signin?verified=true");
            }, 2500);
        } catch (error) {
            toast.update(ToastID.current , {render: `Failed to Verify Account`, type: "error", isLoading: false, theme: "colored", autoClose: "5000", containerId:"root", position: "top-center"})
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id !== null && token !== null) {
            setLoading(true);
            verifyEmail();
        }
    }, []);


    let content;
    let messageData;

    if (loading) {
        content = (
            <Spinner animation="border" role="status">
                <span className="visually-hidden">Loading...</span>
            </Spinner>
        );
    } else if (verified) {
        content = (
            <p>Email Verified</p>
        );
        messageData = (<p className="text-success">Email successfully verified</p>)
    } else {
        content = (
            <p className="text-danger">Verification Failed</p>
        );
        messageData = (
            <>
                <p>Email verification failed. Link may be expired. Please request a new verification link <u><span style={{cursor: "pointer", color: "blue"}} onClick={() => navigate("/request-account-verification")}>here</span></u></p>
            </>
        )
    }
    return (
        <>
            <Container className="bg-body-secondary rounded-3 justify-content-center my-4 py-4">
                <h1>{content}</h1>
                <Row className="card-background card-font">
                    <Row>
                        {messageData}
                    </Row>
                </Row>
            </Container>
        </>
    );
};
